import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import Loading from "../Loading/Loading";
import ImageModal from "../../../components/ImageModal/ImageModal";
import styles from './newsArticle.module.css';
const NewsArticle = () => {
    const { slug } = useParams(); // Get the slug from URL
    const [article, setArticle] = useState(null);
    const [modalImage, setModalImage] = useState(null);
    const contentRef = useRef();
    useEffect(() => {
        fetch(`/api/news/get_news_by_slug/${slug}`)
            .then((res) => res.json())
            .then((data) => setArticle(data[0]))
            .catch((err) => console.error(err));
    }, [slug]);
    useEffect(() => {
        if (article && contentRef.current) {
            const imgs = contentRef.current.querySelectorAll("img");
            imgs.forEach((img) => {
                img.style.cursor = "pointer";
                img.onclick = () => setModalImage(img.src);
            });
        }
    }, [article]);
    if (!article) return <Loading></Loading>;

    return (
        <>
            <ImageModal src={modalImage} onClose={() => setModalImage(null)} />
            <section ref={contentRef} className={styles.atag} dangerouslySetInnerHTML={{ __html: article.content_html }} />
        </>
    );
};

export default NewsArticle;